import { pdf } from '@react-pdf/renderer'
import { createElement } from 'react'
import { TicketDocument } from './TicketPDF'
import type { Venta, Configuracion } from '@/types/database'

/**
 * Genera el PDF del ticket y abre el diálogo de impresión del sistema.
 * No bloquea el flujo de la venta si falla.
 */
export async function printTicket(venta: Venta, config: Configuracion): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const blob = await pdf(createElement(TicketDocument, { venta, config }) as any).toBlob()
  const url = URL.createObjectURL(blob)

  const iframe = document.createElement('iframe')
  iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:none;'
  document.body.appendChild(iframe)
  iframe.src = url

  iframe.onload = () => {
    iframe.contentWindow?.focus()
    iframe.contentWindow?.print()
    setTimeout(() => {
      try {
        document.body.removeChild(iframe)
        URL.revokeObjectURL(url)
      } catch { /* ya fue removido */ }
    }, 10_000)
  }
}
